var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleeManagment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.08 2.92H7.92a5 5 0 0 0-5 5v16.16a5 5 0 0 0 5 5H18a1 1 0 1 0 0-2H7.92a3 3 0 0 1-3-3V11.66h22.16v3.44a1 1 0 0 0 2 0V7.92a5 5 0 0 0-5-5zM4.92 9.66V7.92a3 3 0 0 1 3-3h16.16a3 3 0 0 1 3 3v1.74z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.12 6.34a1.24 1.24 0 1 0 1.24 1.24 1.24 1.24 0 0 0-1.24-1.24zM8.88 6.34a1.24 1.24 0 0 0 0 2.48 1.24 1.24 0 0 0 0-2.48zM27.67 17.5 17 21.64a1 1 0 0 0-.63 1 1 1 0 0 0 .75.9l3.63.92.25 3.76a1 1 0 0 0 .76.9 1 1 0 0 0 1.09-.44L28.88 19a1 1 0 0 0-.08-1.17 1 1 0 0 0-1.13-.33zM22.78 25l-.09-1.38a1 1 0 0 0-.76-.91l-1.28-.32 5-1.92z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleeManagment);
export default __webpack_public_path__ + "static/media/schedulee-managment.87ef50d4770739b95495706d7ee2683a.svg";
export { ForwardRef as ReactComponent };